(function () {
  function drawQr(el, url) {
    if (!el || !url || typeof qrcode !== 'function') return;
    var qr = qrcode(0, 'M');
    qr.addData(url);
    qr.make();
    el.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
    var svg = el.querySelector('svg');
    if (svg) {
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', el.getAttribute('data-qr-label') || 'QR code for the scan link');
    }
    el.hidden = false;
  }

  // Heritage: one fixed link
  document.querySelectorAll('[data-scan-qr]').forEach(function (el) {
    drawQr(el, el.getAttribute('data-scan-qr'));
  });

  // Order-confirmation links carry purchased evaluation context. This controls
  // presentation only; appointment eligibility is confirmed by the team.
  var scanContext = new URLSearchParams(window.location.search);
  var evaluationStep = document.querySelector('[data-paid-evaluation]');
  if (evaluationStep) evaluationStep.hidden = scanContext.get('evaluation') !== 'included';
  function updateGuideLink() {
    var link = document.querySelector('[data-scan-guide]');
    if (!link) return;
    var destination = new URL('https://fore2feet-scan-guide.vercel.app');
    var context = new URLSearchParams(window.location.search);
    ['for', 'evaluation'].forEach(function (key) {
      if (context.has(key)) destination.searchParams.set(key, context.get(key));
    });
    link.href = destination.toString();
  }
  updateGuideLink();

  // MotionForm3D: chooser
  var chooser = document.querySelector('[data-scan-chooser]');
  var card = document.querySelector('[data-scan-result]');
  if (!chooser || !card) return;

  var options = Array.prototype.slice.call(chooser.querySelectorAll('.scan-option'));
  var prompt = card.querySelector('[data-scan-prompt]');
  var ready = card.querySelector('[data-scan-ready]');
  var button = card.querySelector('[data-scan-button]');
  var label = card.querySelector('[data-scan-label]');
  var qrSlot = card.querySelector('[data-scan-qr-slot]');
  var promptTitle = card.querySelector('.scan-prompt-title');
  var promptText = promptTitle && promptTitle.nextElementSibling;
  var defaultTitle = promptTitle ? promptTitle.textContent : '';
  var defaultText = promptText ? promptText.textContent : '';

  var aliases = { 'dress-men': 'dress-men', 'dress-women': 'dress-women', golf: 'golf', tennis: 'tennis', pickleball: 'tennis', lifestyle: 'lifestyle' };

  function find(key) {
    return options.filter(function (o) { return o.getAttribute('data-for') === key; })[0];
  }

  function clear(dress) {
    options.forEach(function (o) {
      o.classList.remove('is-selected');
      o.removeAttribute('aria-current');
      o.classList.toggle('is-suggested', !!dress && o.getAttribute('data-for').indexOf('dress') === 0);
    });
    ready.hidden = true;
    qrSlot.hidden = true;
    qrSlot.innerHTML = '';
    prompt.hidden = false;
    if (dress) {
      promptTitle.textContent = 'Dress shoe: men or women?';
      promptText.textContent = 'Choose the dress shoe you ordered above. The men and women pairs use different scans.';
    } else {
      promptTitle.textContent = defaultTitle;
      promptText.textContent = defaultText;
    }
  }

  function select(opt, push) {
    var url = opt.getAttribute('data-url');
    options.forEach(function (o) {
      o.classList.remove('is-suggested');
      var on = o === opt;
      o.classList.toggle('is-selected', on);
      if (on) o.setAttribute('aria-current', 'true'); else o.removeAttribute('aria-current');
    });
    label.textContent = opt.getAttribute('data-label');
    button.setAttribute('href', url);
    drawQr(qrSlot, url);
    prompt.hidden = true;
    ready.hidden = false;
    if (push && window.history && history.replaceState) {
      try { var next = new URL(window.location.href); next.searchParams.set('for', opt.getAttribute('data-for')); history.replaceState(null, '', next.pathname + next.search); updateGuideLink(); } catch (e) { /* ignore */ }
    }
  }

  options.forEach(function (opt) {
    opt.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      select(opt, true);
      if (window.matchMedia && window.matchMedia('(max-width: 760px)').matches) {
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  });

  var wanted = '';
  try { wanted = (new URLSearchParams(window.location.search).get('for') || '').toLowerCase().trim(); } catch (e) { /* ignore */ }
  if (wanted === 'dress') {
    clear(true);
  } else if (aliases[wanted] && find(aliases[wanted])) {
    select(find(aliases[wanted]), false);
  } else {
    clear(false);
  }
})();
